var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavBasket = function SvgNavBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav_basket_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".nav_basket_svg__st2,.nav_basket_svg__st3{stroke:#000;stroke-miterlimit:10}.nav_basket_svg__st2{fill:none;stroke-width:2.3;stroke-linecap:round;stroke-linejoin:round}.nav_basket_svg__st3{stroke-width:.25}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nav_basket_svg__st3",
    d: "M35.9 17.5c-.3-.4-.8-.6-1.2-.6H18.5c-.2 0-.5.2-.5.5s.2.5.5.5h16.1c.2 0 .4.1.5.2.2.2.2.4.2.5l-1.6 6.8c-.1.5-.6 1-1.2 1H21.6c-.2 0-.5.2-.5.5 0 .2.2.5.5.5h11c1 0 1.9-.8 2.1-1.8l1.6-6.8c.1-.4-.1-1-.4-1.3zM20.9 32.7c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.1-1-2.2-2.2-2.2zm0 3.5c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.2.5 1.2 1.2c0 .6-.5 1.2-1.2 1.2zM30.7 32.7c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2zm0 3.5c-.7 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2 1.3.5 1.3 1.2c0 .6-.6 1.2-1.3 1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "nav_basket_svg__st3",
    d: "M32.4 29.8H19.2L18 25l-2.4-10.4c-.2-.6-.7-1-1.3-1h-3.1c-.2 0-.5.2-.5.5 0 .2.2.5.5.5h3.1c.2 0 .4.2.4.3l2.3 9.8v.1l.2.5 1.3 5.2c.1.2.2.4.5.4h13.6c.2 0 .5-.2.5-.5s-.4-.6-.7-.6z"
  })));
};
export default SvgNavBasket;